import ModalContainer from "../../containers/Modal/ModalContainer";
import { useTranslation } from "react-i18next";
import "../styles/forms.scss";

export default function ModalUndoHiring({
  showModal,
  setShowModal,
  undoHiringCandidate,
  setUndoHiringCandidate,
  submitButton
}) {
  const { t } = useTranslation();
  const onChangeComment = ({ target }) => {
    setUndoHiringCandidate({
      ...undoHiringCandidate,
      comment: target.value
    });
  };

  return (
    <ModalContainer
      modalTitle={t("Undo candidate hiring")}
      submitButtonTitle={t("Confirm")}
      submitButtonAction={submitButton}
      closeModal={() => {
        setShowModal(false);
      }}
      isOpen={showModal}
      cancelButtonTitle={t("Cancel")}
      cancelButtonAction={() => {
        setShowModal(false);
      }}
    >
      <div style={{ marginBottom: "20px" }}>
        <div>
          <span>
            {t("Are you sure you want to continue with this action?")}
          </span>
        </div>
        <div>
          <span>
            {t(
              "If you confirm this action the candidate will be marked with EX-EMPLOYEE status, and will be available again in the interview list."
            )}
          </span>
        </div>
      </div>
      <div className="form-group">
        <div className="label-wrapper">
          <label className="form-label">{t("Comments")}</label>
        </div>
        <textarea
          onChange={onChangeComment}
          value={undoHiringCandidate.comment}
          name="comment"
          maxLength="500"
        ></textarea>
      </div>
    </ModalContainer>
  );
}
